import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
class ProductDetail extends Component {

    constructor(props) {
        super(props);
        this.state = { productDetail: props.productDetail, loading: false, alertMessage: "", };
        this.history = props.history;
    }
    render() {
        return (
            <div>
                <Card >
                    <Card.Body>
                        <Card.Title>{this.state.productDetail.Account}</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">Product: {this.state.productDetail.CODE}</Card.Subtitle>
                        <Card.Text>
                            <span><b>Description:</b> {this.state.productDetail.DESCRIPTION}</span><br/>
                            <span><b>Species:</b> {this.state.productDetail.Description2}</span><br />
                            <span><b>Default Pack:</b> {this.state.productDetail.Pack}</span><br />
                            <span><b>QTY Eachs:</b> {this.state.productDetail.PACKSIZE}</span><br />
                            <span><b>DG Name:</b> {this.state.productDetail.DGShippingName}</span><br />
                            <span><b>Marine Pol:</b> {this.state.productDetail.DGMarinePolutant}</span>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}
export default ProductDetail;
